module.exports = __webpack_public_path__ + "media/img/events/bg/registration-89f911d340efc6812476abfab56311e9.jpg";